import * as DEPT_API from '@/api/department'

export default {
  state: {
    departmentsList: []
  },
  getters: {
    departmentsList: state => state.departmentsList
  },
  mutations: {
    setDeparments: (state, departments) => {
      state.departmentsList = departments
    }
  },
  actions: {
    getDepartments ({ commit }) {
      return DEPT_API.getDepartments().then(res => {
        commit('setDeparments', res.data)
        return res
      })
    }
  }
}
